<template>
  <div
    class="header"
    :style="
      show
        ? 'height:100vh;background-color:rgba(255,255,255,.85)'
        : 'background-color:rgba(255,255,255,1)'
    "
  >
    <van-overlay
      :show="show"
      z-index="2"
      :custom-style="{ 'background-color': 'rgba(255,255,255,.85)' }"
    >
      <ul class="wrapper" @click="show = false">
        <li class="block"></li>
        <router-link class="block" tag="li" to="/">首页</router-link>
        <router-link class="block" tag="li" to="/course">课程</router-link>
        <router-link class="block" tag="li" to="/teachers">师资</router-link>
        <router-link class="block" tag="li" to="/abilityTest"
          >中文水平测试</router-link
        >
        <router-link class="block" tag="li" to="/league">商务合作</router-link>
      </ul>
    </van-overlay>

    <div class="logo"></div>
    <div class="close" @click="show = true"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>
<style lang='scss' scope>
.header {
  width: 100vw;
  height: 40px;
  display: flex;
  align-items: top;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  background-color: #fff;
  z-index: 3;
  box-shadow: 1px 2px 12px 1px rgba($color: #666666, $alpha: 0.3);
  transition: all 0.3s;

  .logo {
    margin-left: 20px;
    width: 100px;
    height: 31px;
    background-image: url("../../assets/images/logo@2x.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    z-index: 99;
    margin-top: 4px;
  }
  .close {
    margin-right: 20px;
    width: 18px;
    height: 18px;
    background-image: url("../../assets/images/logo@2x.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    z-index: 99;
    margin-top: 12px;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    height: 100%;
  }
  .block {
    width: 290px;
    height: 55px;
    text-align: center;
    line-height: 60px;
    font-size: 15px;
    letter-spacing: 1.15px;
    color: #323232;
    border-bottom: 1px solid #b5c1d0;
    font-weight: 700;
    &:nth-last-child(1),
    &:nth-child(1) {
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/index.vue